import React from "react";
import Title from "../layouts/Title";
import {
  firefly,
  Gemini_security_scout,
  container,
  customerFeedback,
  secureFileVault,
  githubActions,
  LinkPulse,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="LinkPulse"
          des="High-performance URL-shortening API with FastAPI, cache-aside PostgreSQL/Redis data layer, and event-driven analytics."
          src={LinkPulse}
          items={[
            "Built a URL-shortening API with FastAPI, supporting link creation, redirects, health checks, and per-link click statistics.",
            "Designed a cache-aside data layer using PostgreSQL as the source of truth and Redis to deliver low-latency redirects.",
            "Created an event-driven analytics pipeline with Amazon SQS and a Go worker to capture click events and calculate hourly usage data.",
            "Developed analytics endpoints for overall activity, top-performing links, recent clicks, and 24-hour per-link trends.",
            "Enforced infrastructure quality and security with pre-push hooks that run Terraform formatting checks and Checkov scans before changes are shared.",
            "Automated releases with GitHub Actions OIDC, immutable Docker image tags, and CodeDeploy blue/green deployments.",
          ]}
        />
        <ProjectsCard
          title="Cloud Security Scout"
          des="In this Project we focused on the key Cloud Security Principles. These are:"
          src={Gemini_security_scout}
          githubLink="https://github.com/cmomodo/cloud_security/tree/main/cloud_security_scout"
          items={[
            "Comprehensive Discovery",
            "Consistent Evaluation",
            "Timely Protection",
            "Prioritising Remediation",
          ]}
        />
        <ProjectsCard
          title="Parallel & Distributed Programming"
          des="We implemented a parallel and distributed programming project using MPI and OpenMP. The project was to implement a Weather Climate Model."
          src={githubActions}
          githubLink="https://github.com/cmomodo/Distributed-Parallel-"
        />
        <ProjectsCard
          title="Containerisation"
          des="In this project we focused on Docker. What we covered were the core fundamentals on how docker can be used more efficiently:"
          src={container}
          githubLink="https://github.com/cmomodo/Docker_Learning-.git"
          items={[
            "Multi-builds",
            "Docker Compose",
            "Docker Volumes",
            "Docker Networks",
          ]}
        />
        <ProjectsCard
          title="Ansbile Deployment"
          des="This load balancer was created using Terraform. The load balancer is used to distribute incoming network traffic across multiple servers.Ansible was used to deploy the application to the servers."
          src={firefly}
          githubLink="https://github.com/cmomodo/ansible"
        />
        <ProjectsCard
          title="Customer Service App"
          des="Cloud-native AWS customer feedback app with secure CI/CD, compliance checks, and lower networking costs."
          src={customerFeedback}
          githubLink="https://github.com/cmomodo/customer_feedback_ECS.git"
          items={[
            "Architected and deployed the application on AWS using containerised workloads.",
            "Integrated Trivy into the pipeline to perform container image vulnerability scanning, identifying and remediating critical and high CVE findings before deployment.",
            "Used Checkov to perform Infrastructure-as-Code (IaC) static analysis, ensuring Terraform configurations complied with security best practices and AWS standards.",
            "Implemented a full CI/CD pipeline to enable automated, repeatable, and reliable deployments with validation gates for security scans.",
            "Replaced NAT Gateway architecture with VPC Endpoints (Interface and Gateway endpoints) to enable private service communication and reduce outbound traffic costs.",
            "Achieved approximately 30% cost reduction by leveraging VPC Endpoints instead of NAT Gateway for AWS service access.",
            "Strengthened overall cloud posture through early vulnerability detection and compliance validation in the deployment lifecycle.",
          ]}
        />
        <ProjectsCard
          title="Secure File Vault"
          des="AWS file vault with encrypted storage, secure access, and audit logging."
          src={secureFileVault}
          githubLink="https://github.com/cmomodo/cloud_security.git"
          items={[
            "Built a secure cloud file vault using Amazon S3, Cognito, and Lambda, enabling encrypted file storage and authenticated user access.",
            "Implemented S3 lifecycle policies to automatically archive inactive files, reducing storage costs by 30%.",
            "Automated least-privilege access testing with Bash scripts to validate IAM permissions and strengthen security controls.",
            "Implemented audit logging with AWS Lambda and CloudWatch to track uploads and user actions for monitoring and compliance.",
          ]}
        />
      </div>
    </section>
  );
};

export default Projects;
